<template>
  <div class="widget w-account-details-widget">
    <c-widget-header :wid="wid">
      <span class="w-account-details-widget__name">{{ $t('white-label.widgets.accountDetails') }}</span>
      <slot name="buttons" slot="buttons" />
      <c-widget-sortable-tabs-bar
        :tabs="tabs"
        :tabClasses="tabClasses"
        @dragend="onDragend"
        @rename="onRename"
        @select="onSelect"
        @remove="onRemove"
        @add="onAdd"
      />
    </c-widget-header>

    <div class="widget-body w-account-details-widget__name">
      <c-price-entry
        :lockTypes="priceEntryTabs"
        :value="price"
        :lock="lockSelected"
        @selected="lockSelect"
        @reset="lockReset"
      ></c-price-entry>
      <component :is="componentsToLoad"></component>
    </div>
  </div>
</template>

<script>
import CWidgetHeader from '@custom/widgetContainer/CWidgetHeader';
import CWidgetHeaderButton from '@custom/widgetContainer/CWidgetHeaderButton';
import CWidgetSortableTabsBar from '@custom/widgetContainer/CWidgetSortableTabsBar';
import COrderStatus from '@custom/COrderStatus';
import CPriceEntry from '@custom/CPriceEntry';
import TD from '@state/td';

export default {
  name: 'w-account-details-widget',
  components: { CWidgetHeader, CWidgetHeaderButton, CWidgetSortableTabsBar, COrderStatus, CPriceEntry },
  props: {
    wid: {
      type: String,
      required: true
    }
  },
  computed: {
    ricValue() {
      return this.$store.state.widget[this.wid].ric;
    }
  },
  data() {
    return {
      componentsToLoad: '',
      price: '',
      lockSelected: 'none',
      priceEntryTabs: [
        { name: 'None', lock: 'none', icon: 'lock' },
        { name: 'Follow Bid', lock: 'bid', icon: 'lock' },
        { name: 'Follow Ask', lock: 'ask', icon: 'lock' }
      ],
      tabs: [
        { name: 'Holdings', editable: false, id: 0, active: true },
        { name: 'Order Status', editable: false, id: 1, active: false },
        { name: 'Historical Orders', editable: false, id: 2, active: false }
      ],
      tabClasses: [{ name: 'Holdings' }, { name: 'Order Status' }, { name: 'Historical Orders' }]
    };
  },
  methods: {
    getComponentDeclaration(components) {
      switch (components) {
        case 'Order Status':
          return 'COrderStatus';
        default:
          return '';
      }
    },
    lockSelect(data) {
      this.lockSelected = data.limit.lock;
    },
    lockReset(data) {
      this.lockSelected = data.lock;
    },
    onDragend(tabs) {
      console.log('ONDRAGEND', tabs);
    },
    onSelect(tab) {
      console.log('ONSELECT', tab);
      this.componentsToLoad = this.getComponentDeclaration(tab.name);
    },
    onRemove(tab) {
      console.log('ONREMOVE', tab);
    },
    onRename(tab) {
      console.log('ONRENAME', tab);
    },
    onAdd(tab) {
      console.log('ONADD', tab);
    }
  },
  mounted() {
    TD.get('/waw/brk/wb/services/rest/v2/accountsV2').then(response => console.log(response));
  }
};
</script>
<style lang="scss">
@import '~@/styles/widgets/account-details-widget';
</style>
